import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, AlertTriangle, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { dateTR } from "../lib/format";

export default function SubscriptionBanner() {
  const [sub, setSub] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/subscription");
        setSub(res.data);
      } catch (e) {
        // ignore
      }
    })();
  }, []);

  if (!sub) return null;
  if (sub.status === "active") {
    // show only when close to expiry (< 7 days)
    if (sub.days_left > 7) return null;
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50/60 p-4 flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0" />
        <div className="flex-1 text-sm text-amber-900">
          Aboneliğinizin bitmesine <b>{sub.days_left} gün</b> kaldı.
          Kesintisiz kullanım için yenileyin.
        </div>
        <Link
          to="/abonelik"
          data-testid="banner-renew"
          className="h-9 px-4 rounded-full bg-amber-700 hover:bg-amber-800 text-white text-sm font-semibold flex items-center gap-1.5"
        >
          Yenile <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    );
  }
  if (sub.status === "trial") {
    return (
      <div className="rounded-2xl border border-orange-200 bg-orange-50/60 p-4 flex items-center gap-3">
        <Sparkles className="w-5 h-5 text-orange-700 shrink-0" />
        <div className="flex-1 text-sm text-orange-900">
          <b>Deneme sürümü aktif.</b> {sub.trial_days_left} gün ücretsiz
          kullanımınız kaldı (bitiş: {dateTR(sub.trial_end)}).
        </div>
        <Link
          to="/abonelik"
          data-testid="banner-plans"
          className="h-9 px-4 rounded-full bg-orange-700 hover:bg-orange-800 text-white text-sm font-semibold flex items-center gap-1.5"
        >
          Planları gör <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    );
  }
  // expired / trial_expired / none
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/60 p-4 flex items-center gap-3" data-testid="banner-expired">
      <AlertTriangle className="w-5 h-5 text-rose-700 shrink-0" />
      <div className="flex-1 text-sm text-rose-900">
        <b>Aboneliğiniz yok veya süresi dolmuş.</b> Yeni araç eklemek ve
        aktif kullanmak için bir plan seçin.
      </div>
      <Link
        to="/abonelik"
        data-testid="banner-choose-plan"
        className="h-9 px-4 rounded-full bg-rose-700 hover:bg-rose-800 text-white text-sm font-semibold flex items-center gap-1.5"
      >
        Plan seç <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
}
